import { dedupeDispensary } from '@iheartjane/utils';
import Mustache from 'mustache';

type MetaProps = {
  fulfillmentMode?: string | null;
  pinnedStoreCity?: string | null;
  pinnedStoreName?: string | null;
  pinnedStoreState?: string | null;
  reservationMode?: string | null;
};

const safeMustacheRender = (
  template: string,
  variables: Record<string, string>
): string => {
  try {
    return Mustache.render(
      template,
      variables,
      {},
      { escape: (text: string) => text }
    );
  } catch {
    return template;
  }
};

export function createMetaVariables(
  metaProps: MetaProps = {},
  additionalProps = {}
) {
  return {
    storeCity: metaProps.pinnedStoreCity ?? '',
    storeFulfillment: metaProps.fulfillmentMode ?? '',
    storeName: metaProps.pinnedStoreName ?? '',
    storeStateAbbr: metaProps.pinnedStoreState ?? '',
    storeType: metaProps.reservationMode ?? '',
    ...additionalProps,
  };
}

export function createMetaItem(
  hasCustomSEO: boolean,
  metaVariables: Record<string, string>,
  customString: string,
  defaultString: string
) {
  const rendered = hasCustomSEO
    ? safeMustacheRender(customString, metaVariables)
    : safeMustacheRender(defaultString, metaVariables);

  return dedupeDispensary(rendered);
}
